import { AssetContext } from '@pages/Asset/Asset.query';
import { useContext } from 'react';
import { PicturesOverview } from './components';
import { PicturesAdd } from './components/PicturesAdd/PicturesAdd';
import { Container, Photo, NoPhotos, RowButton } from './Photos.styles';

export const Photos = () => {
  const {
    picturesQuery,
    show,
    setShow,
    setSelectedPicture,
    selectedPicture,
    setShowAdd,
    showAdd,
  } = useContext(AssetContext);

  const picutres = picturesQuery?.data;

  if (
    !picturesQuery ||
    picturesQuery.isError ||
    picturesQuery.isLoading ||
    !picutres
  ) {
    return <div />;
  }

  return (
    <Container>
      {picutres.map(item => (
        <Photo
          key={item.id}
          onClick={() => {
            setSelectedPicture(item.id);
            setShow(true);
          }}
          src={item.type === 'uri' ? item.uri : item.file?.uri}
        />
      ))}

      {picutres.length === 0 && (
        <NoPhotos>
          This asset has no photos.{' '}
          <RowButton
            text="b200"
            textColor="b401"
            onClick={() => setShowAdd(true)}
          >
            Add a Photo
          </RowButton>
        </NoPhotos>
      )}

      {show && (
        <PicturesOverview
          setShow={setShow}
          setShowAdd={setShowAdd}
          setSelectedPicture={setSelectedPicture}
          selectedPicture={selectedPicture}
        />
      )}
      {showAdd && <PicturesAdd setShowAdd={setShowAdd} />}
    </Container>
  );
};
